import React, { createContext, useState, useContext } from 'react';

import { ICardDTO } from '@origin-digital/pmservice-dapi-contract';

import { AccountBackend, IPaymentData } from 'src/interfaces';
import { IDivisionIdWithLpg } from 'src/consts';

type Omit<T, K extends string> = Pick<T, Exclude<keyof T, K>>;

export interface IContext {
  contractAccountId?: string;
  divisionId?: IDivisionIdWithLpg | '';
  orderNumber?: string;
  address?: string;
  amount?: string;
  amountDue?: string;
  amountProvided?: string;
  showAmountDue?: boolean;
  payAmountDue?: boolean;
  paymentData?: IPaymentData;
  paymentMethod?: ICardDTO;
  paymentMethodSelectedIdx?: number;
  receiptNumber?: string;
  timestamp?: string;
  started?: boolean;
  saveCard?: boolean;
  backend?: AccountBackend;
}

export interface IPaymentContext extends Omit<IContext, 'amount'> {
  amount: number;
}

export interface IAppContext {
  context: IContext;
  setContext(context: Partial<IContext>): void;
}

export const AppContext = createContext<IAppContext>({
  context: {},
  setContext: /* istanbul ignore next */ () => undefined,
});

export const mergeContext = ({ setContext, context }: IAppContext) => (
  nextContext: Partial<IContext>,
): void =>
  setContext({
    ...context,
    ...nextContext,
  });

export const useAppContext = (): IAppContext => useContext<IAppContext>(AppContext);

export const AppContextProvider: React.SFC = ({ children }) => {
  const [context, setContext] = useState<IContext>({
    started: false,
    saveCard: false,
    showAmountDue: false,
    payAmountDue: false,
  });

  return (
    <AppContext.Provider
      value={{
        context,
        setContext: mergeContext({ setContext, context }),
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
